import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { ToolBar } from 'foundations-components/transitional/components/ToolBar';
import { ToolBarGroup } from 'foundations-components/transitional/components/ToolBarGroup';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { Link } from 'foundations-components/transitional/components/Link';
import { useHistory } from 'quartz-routing/react-router';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AwardShareHeader = ({
  backLinkHref
}) => {
  const {
    isMobile
  } = useMediaQuery();
  const history = useHistory();
  const handleBackClick = () => {
    history.push(backLinkHref);
  };
  return /*#__PURE__*/_jsxs(ToolBar, {
    use: "dark",
    children: [/*#__PURE__*/_jsx(Box, {
      flexGrow: 0,
      children: /*#__PURE__*/_jsx(ToolBarGroup, {
        children: /*#__PURE__*/_jsx(View, {
          position: "absolute",
          children: /*#__PURE__*/_jsx(BackButton, {
            children: /*#__PURE__*/_jsx(Link, {
              onClick: handleBackClick,
              children: !isMobile && /*#__PURE__*/_jsx(FormattedMessage, {
                message: "learningCenter.awardShareControls.back"
              })
            })
          })
        })
      })
    }), /*#__PURE__*/_jsxs(View, {
      inlineSize: "100%",
      textAlign: "center",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.trackAwardModal.shareThisCertificate"
        })
      }), /*#__PURE__*/_jsx(Small, {
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.awardShareControls.pleaseAcceptTerms"
        })
      })]
    })]
  });
};
export default AwardShareHeader;